import {DictionaryItem} from './dictionary.model';

export class Address {
    apartmentNumber: string;
    city: string;
    country: string;
    streetNumber: string;
    postOffice: string;
    street: string;
    streetPrefix: string | DictionaryItem;
    voivodeship: string;
    postalCode: string;
    fullAddress: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}
